import { BookIcon } from 'assets/icons';
import { classnames } from 'helpers/utils';
import styles from './vault-avatar.module.scss';

interface VaultAvatarProps {
  imageURL?: string;
  isLockedOrRestrictedVault: boolean;
  isSmall?: boolean;
}

export const VaultAvatar: React.FC<VaultAvatarProps> = ({
  imageURL,
  isLockedOrRestrictedVault,
  isSmall = false,
}) => (
  <div
    className={classnames(styles.vaultAvatar, {
      [styles.isSmall]: isSmall,
      [styles.lockedOrRestricted]: isLockedOrRestrictedVault,
    })}
  >
    {imageURL ? <img src={imageURL} alt="" /> : <BookIcon />}
  </div>
);
